export default {
    data: () => ({
        lendingKitModel: {
            identifier: '',
            codentify: '',
            child_codentify_1: '',
            child_codentify_2: '',
            lending_point_id: null,
            stock_status_id: null,
            status_id: null,
            is_circular_lending: false,
            lending_count: 0,
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/lendingKitModel.js